//email-preview/src/features/root/RootComponent.tsx
// checks for session and navigates accordingly

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const RootComponent = () => {
  const navigate = useNavigate();
  const isLoggedIn = true; // Hardcoded for now

  useEffect(() => {

    if (isLoggedIn) {
      navigate('/email-preview'); // Redirect to Email Preview
    } else {
      navigate('/auth/login')
    }
  })

  return (
    <></>
  )

}